module.exports = __webpack_public_path__ + "img/honour_have.af1cf0e9.png";